import gql from 'graphql-tag';

import { lessonTemplateFragment } from '~/shared/graphql-queries/lesson-templates/index';

export default gql`
  query findManyLessonTemplateQuery(
    $limit: Int = 20
    $filter: FilterFindManyLessonTemplateInput
  ) {
    findManyLessonTemplateQuery(
      filter: $filter
      skip: 0
      limit: $limit
      sort: _ID_ASC
    ) {
      ...LessonTemplateFragment
    }
  }
  ${lessonTemplateFragment}
`;
